var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkedCircle)?_c('icon',{staticClass:"w-6 h-6",class:_vm.statusColor,attrs:{"name":_vm.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }